import baguetteBox from 'baguettebox.js';

export default function() {
    const imageGallery = document.getElementById('imageGallery');

    if (imageGallery) {
        baguetteBox.run('.c-gallery', {
            buttons: true,
            captions: true
        });
    }
}
